import React from "react";
import { KitchenClockProvider, useKitchenNow } from "../../KDS/components/TimedOrderCard";
import { getTableKitchenStatus } from "../tableServingTiming";
import ServingTimingBadge from "./ServingTimingBadge/ServingTimingBadge";

// Kitchen data comes from getTableStatusByCart (table.kitchenJobs), so no separate filterJobs poll.
// The provider only supplies the shared clock that drives the countdown.
export function TableServingTimingProvider({ children }) {
  return <KitchenClockProvider>{children}</KitchenClockProvider>;
}

export default function TableKitchenTiming({ table }) {
  const now = useKitchenNow();
  const summary = getTableKitchenStatus(table, now);
  if (!summary) return null;
  return <ServingTimingBadge summary={summary} />;
}
